<template>
  <div class="x-misscenlist-box" style="margin:15px">
    <div class="x-miss-title">任务名称：{{misstitle}}</div>
    <el-table :data="misslist" style="width: 100%;text-align:center" ref="multipleTable" border v-loading="allmainproloading">
      <el-table-column type="index" width="50">
      </el-table-column>
      <el-table-column label="学员" width="">
        <template slot-scope="scope">
          <span style="margin-left: 10px" v-if="scope.row.username != null">{{ scope.row.username }}</span>
          <span style="margin-left: 10px" v-else></span>
        </template>
      </el-table-column>
      <el-table-column label="待学习课程" width="">
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{ scope.row.pend_study }}</span>
        </template>
      </el-table-column>
      <el-table-column label="待考试数" width="">
        <template slot-scope="scope">
          {{ scope.row.pend_exam }}
        </template>
      </el-table-column>
      <el-table-column label="总进度" width="">
        <template slot-scope="scope">
          {{ (scope.row.rate) }} %
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" width="">
        <template slot-scope="scope">
          <router-link :to="{name:'userdetails',params:{userid:scope.row.memberid,username:scope.row.username}}" class="x-text-see" @click="seeuser(scope.row.memberid)">查看详情</router-link>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- <el-pagination
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pagesize"
      layout="total, prev, pager, next, jumper"
      :total="misslist.length"
      background class="x-pagination">
    </el-pagination> -->
    <!--二级查看弹窗-->
    <el-dialog title="添加部门" :visible.sync="addbranch" class="x-addb-hed" :close-on-click-modal='noshowmodal'>
      <div class="x-addclass-box">

      </div>
      <div slot="footer" class="dialog-footer">
        <div class="x-btn x-btn-bl">添加</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'missioncenterlist',
  data () {
    return {
      misslist:[],
      misslistid:'',
      allmainproloading:true,
      currentPage:1,//默认显示第几页
      pagesize:20,//每页个数
      misstitle:'',
      addbranch:false,
      userdone:'',
      userundone:'',
      noshowmodal:false
    }
  },
  created() {
    console.log('任务中心详细id：'+this.$route.params.missid);
    console.log('任务中心详细标题：'+this.$route.params.misstitle);
    this.misslistid = this.$route.params.missid;
    this.misstitle = this.$route.params.misstitle;
    this.misscenlist()
  },
  methods:{
    seetask(){

    },
    misscenlist(){
      axios.get('/admin/task/complete', {
        params: {
          sec: localStorage.token,
          id:this.misslistid
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            this.allmainproloading = false;
            console.log(response.data.data);
            this.misslist = response.data.data
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    handleCurrentChange(val){
      console.log(`当前页: ${val}`);
    },
    // 查看学员
    seeuser(id){
      this.addbranch = true;
      console.log(id);
      axios.get('/learn/task/memberTaskList', {
        params: {
          sec: localStorage.token,
          memberId:id
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
            console.log(response.data.data.list);
            this.userdone = response.data.data.list.done;
            this.userundone = response.data.data.list.undone;
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    }
  }
}
</script>

<style>
.x-misscenlist-box .el-table th.is-leaf{
  text-align: center;
}.x-misscenlist-box .el-table thead tr th{
  background-color: #F2F2F2;
}.x-misscenlist-box .el-table td{
  text-align: center;
}.x-pagination{
  margin-top: 20px;
}.x-miss-title{
  text-align: left;
  font-size: 14px;
  padding-bottom: 20px;
}
</style>
<style media="screen">

</style>



// WEBPACK FOOTER //
// src/components/missioncenterlist.vue